module.exports = __webpack_public_path__ + "img/hand-wave.2ba92e39.svg";